<template>
  <div class="tab-body">
    <el-row class="autoFlex" :gutter="10">
      <el-col :span="5">
        <el-card class="leftCard">
          <div slot="header" class="clearfix">
            <span>分类列表</span>
            <!-- 树展开，树收缩 -->
            <el-button
              @click="disSelectTree"
              class="expandBtn"
              type="primary"
              icon="el-icon-s-fold"
              size="small"
              style="margin-left: 10px"
              node-key="qid"
            ></el-button>
            <!-- 添加分类 -->
            <el-button
              v-if="showAdd"
              @click="addKind()"
              class="expandBtn"
              type="primary"
              icon="el-icon-plus"
              size="small"
              style="margin-left: 10px"
              node-key="qid"
            >
            </el-button>

            <!-- 移除分类 -->
            <el-button
              v-if="showDelect"
              @click="remove()"
              class="expandBtn"
              type="primary"
              icon="el-icon-minus"
              size="small"
              style="margin-left: 10px"
              node-key="qid"
            >
            </el-button>

            <!-- 修改分类 -->
            <el-button
              @click="toUpdate()"
              class="expandBtn"
              type="primary"
              icon="el-icon-edit"
              size="small"
              style="margin-left: 10px"
              node-key="qid"
            >
            </el-button>
          </div>
          <tree
            v-loading="treeLoading"
            ref="kindsTree"
            :items="kindsList"
            :defaultExpandAll="treeExpand"
            :defaultParent="0"
            @nodeClick="treeClick"
          ></tree>
        </el-card>
      </el-col>

      <el-col :span="19">
        <el-card class="rightCard" v-if="showQuestion">
          <div>
            <div>
              <el-button type="primary" @click="selectSub">{{
                sbname ? "重选" : "选择"
              }}</el-button>
              <el-button type="danger" @click="back()">全部题库</el-button>
              <el-button
                type="warning"
                v-if="selectQueids.length == 1"
                @click="showOneQue(1)"
                >查看备选题目</el-button
              >
              <el-button
                type="success"
                v-if="selectRightQueids.length == 1"
                @click="showOneQue(2)"
                >查看已选题目</el-button
              >
            </div>
          </div>
          <!-- 穿梭框选择器 -->
          <el-transfer
            filterable
            filter-placeholder="请输入搜索内容"
            v-model="rightTransferQIDs"
            :data="leftTransfer"
            :titles="[
              (sbname ? sbname : '全部') + ' ~ 备选题目',
              (kindInfo.name ? kindInfo.name : '未选择') + ' ~ 已选题目',
            ]"
            @change="handleChange"
            @left-check-change="selectQues"
            @right-check-change="selectRightQues"
          >
          </el-transfer>
        </el-card>
        <el-card v-if="!showQuestion">
          <el-button @click="prevPDF()" style="width: 80px">上一页</el-button>
          <el-button @click="nextPDF()" style="width: 80px">下一页</el-button>
          {{ currentPage }} / {{ pageCount }}

          <div class="pdf-container" v-if="kindInfo.url">
            <pdf
              ref="pdf"
              :src="BASEURL + kindInfo.url"
              @progress="onProgress"
              @error="onError"
              style="width: 80%"
              @num-pages="pageCount = $event"
              @page-loaded="currentPage = $event"
            >
            </pdf>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <!-- 选择科目 -->
    <el-dialog
      title="选择绑定科目"
      :visible.sync="dialogVisible"
      width="60%"
      :append-to-body="true"
    >
      <tree
        class="filter-tree"
        ref="permissionTree"
        check-strictly
        :items="permissionList"
        :data="permissionList"
        :defaultParent="0"
        @nodeClick="treeSubClick"
        :expand-on-click-node="true"
      >
      </tree>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="comfirmSub">选定科目</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="考题查询"
      :visible.sync="showOneQuession"
      width="60%"
      :append-to-body="true"
    >
      <div v-if="showOneQuession">
        【{{
          oneQuession.type == 1
            ? "单选"
            : oneQuession.type == 2
            ? "多选"
            : oneQuession.type == 3
            ? "判断"
            : "简答"
        }}题】 {{ oneQuession.name }} <br />
        .
        <hr />
        <br />
        <el-row
          v-for="(itm, index) in oneQuession.content.choiceList"
          v-bind:key="index"
        >
          <el-col :span="24">
            &nbsp;&nbsp;&nbsp;&nbsp;{{ itm.o }}. &nbsp; &nbsp; {{ itm.n }}
          </el-col>
        </el-row>
        <hr />
        <br />
        答案:{{ oneQuession.answer }}
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeShOneQue">关闭</el-button>
      </span>
    </el-dialog>
    <edit ref="edit"></edit>
  </div>
</template>
<script>
import edit from "./edit.vue";
import pdf from "vue-pdf";
import tree from "@/components/tree/tree.vue";
import subApi from "@/api/edu/subject/subject.js";
import api from "@/api/online/kinds/kinds.js";
import queApi from "@/api/exams/question/question.js";
import qlhTable from "@/components/qlhTable/qlhTable.vue";
import qlhTableColumn from "@/components/qlhTable/qlhTableColumn.vue";
import constant from "@/util/constant.js";

export default {
  name: "kinds",
  components: {
    tree,
    edit,
    qlhTable,
    qlhTableColumn,
    pdf,
  },
  data() {
    return {
      BASEURL: constant.serverUrl,
      treeLoading: false,
      treeRef: "kindsTree",
      treeExpand: true,
      showQuestion: false, // 切换题目分类和浏览pdf页面
      src: "", //pdf地址
      currentPage: 0, //pdf当前页数
      pageCount: 0, // pdf总页数
      kindsList: [], //分类的信息
      transferProps: {
        key: "qid", // 数据项的唯一标识
        label: "name", // 显示标签
      },
      sbid: "0", //科目id
      sbname: "", //科目名字
      dialogVisible: false, //科目弹框开关
      //课程-模块-科目信息 全部数据
      orgPermissionList: null,
      permissionList: null,
      chooseQList: [],
      showAdd: true, //添加
      showDelect: false, //删除
      currentNode: {},

      kindInfo: {},

      excelProp: {
        excelName: "部门信息",
        sheetname: "部门信息",
      },
      //data: generateData(),
      //value: generateValue(),

      leftTransfer: [], // 左边穿梭框
      rightTransferQIDs: [], //右边穿梭框qids

      selectQueids: [],
      selectRightQueids: [],
      oneQuession: null,
      showOneQuession: false,

      id: "", //树状图选择时修改
      name: "", //分类的名称,
      qid: "", //移动的问题id(可多选)
      pid: "0", //判断是否为根节点
    };
  },
  methods: {
    showOneQue(type) {
      let qid = 0;
      if (type == 1) {
        //备选
        qid = this.selectQueids[0];
      } else {
        qid = this.selectRightQueids[0];
      }

      queApi.toUpdate({ id: qid }, (res) => {
        this.oneQuession = res.data;
        if (this.oneQuession.content) {
          this.oneQuession.content = JSON.parse(this.oneQuession.content);
        }
        this.showOneQuession = true;
      });
    },
    closeShOneQue() {
      this.oneQuession = null;
      this.showOneQuession = false;
    },
    selectQues(data) {
      this.selectQueids = data;
    },
    selectRightQues(data) {
      this.selectRightQueids = data;
    },
    // 输出提取的 qid 数组
    extractQids(arrs) {
      this.rightTransferQIDs = arrs.map((item) => item.qid);
      return this.rightTransferQIDs;
    },
    generateData(type, arrs) {
      const leftTransfer = [];

      for (let i = 0; i < arrs.length; i++) {
        if (type == 1) {
          //左边
          leftTransfer.push({
            key: arrs[i].qid,
            label: arrs[i].qname,
          });
        } else {
          //右边
          leftTransfer.push({
            // label: arrs[i].qname,
            key: arrs[i].qid,
          });
        }
      }
      return leftTransfer;
    },

    //获取数据
    list() {
      this.treeLoading = true;
      api.list({}, (response) => {
        this.kindsList = response.data;

        for (let idx = 0; idx < this.kindsList.length; idx++) {
          switch (this.kindsList[idx].popIdx) {
            case 1:
              this.kindsList[idx].name = "①⭐" + this.kindsList[idx].name;
              break;
            case 2:
              this.kindsList[idx].name = "②⭐" + this.kindsList[idx].name;
              break;
            case 3:
              this.kindsList[idx].name = "③⭐" + this.kindsList[idx].name;
              break;
            case 4:
              this.kindsList[idx].name = "④⭐" + this.kindsList[idx].name;
              break;
            case 5:
              this.kindsList[idx].name = "⑤⭐" + this.kindsList[idx].name;
              break;
            case 6:
              this.kindsList[idx].name = "⑥⭐" + this.kindsList[idx].name;
              break;
            case 7:
              this.kindsList[idx].name = "⑦⭐" + this.kindsList[idx].name;
              break;
            case 8:
              this.kindsList[idx].name = "⑧⭐" + this.kindsList[idx].name;
              break;
            case 9:
              this.kindsList[idx].name = "⑨⭐" + this.kindsList[idx].name;
              break;
            case 10:
              this.kindsList[idx].name = "⑩⭐" + this.kindsList[idx].name;
              break;
            case 11:
              this.kindsList[idx].name = "⑪⭐" + this.kindsList[idx].name;
              break;
            case 12:
              this.kindsList[idx].name = "⑫⭐" + this.kindsList[idx].name;
              break;
          }
        }

        this.treeLoading = false;
        this.showQuestion = true;

        if (this.kid) {
          if (this.sbid == "0") {
            //默认选中
            this.selectQ();
          } else {
            //点击科目后查询
            this.selectQBySbid(this.sbid, this.kid);
          }
        }
      });
    },
    back() {
      if (this.kid) {
        this.closeShOneQue();
        this.selectQueids = [];
        this.selectRightQueids = [];
        this.sbid = null;
        this.selectQ(this.kid);
        this.sbname = "";
      }
    },
    // 选择科目
    selectSub() {
      this.closeShOneQue();
      this.selectQueids = [];
      this.selectRightQueids = [];
      if (this.kid) {
        this.dialogVisible = true;
        if (!this.orgPermissionList) {
          subApi.list({}, (response) => {
            this.orgPermissionList = response.data;
            this.permissionList = this.orgPermissionList;
          });
        } else {
          this.permissionList = this.orgPermissionList;
        }
      }
    },
    treeSubClick(data) {
      this.subData = data;
      this.showDelect = true;
      this.showAdd = false;
    },
    comfirmSub() {
      this.sbname = this.subData.name;

      this.sbid = this.subData.id;

      this.selectQBySbid(this.sbid, this.kid);
      this.dialogVisible = false;
    },
    //收树状
    expandTree() {
      this.treeExpand = !this.treeExpand;
      this.kindInfo = {};
      this.rightTransferQIDs = null;

      //控制el-tree展开收起
      for (
        var i = 0;
        i < this.$refs.kindsTree.getTree().store._getAllNodes().length;
        i++
      ) {
        this.$refs.kindsTree.getTree().store._getAllNodes()[i].expanded =
          this.treeExpand;
      }
    }, //不选择
    disSelectTree() {
      this.$refs.kindsTree.getTree().setCurrentKey(null);

      this.kindInfo = {};
      this.rightTransferQIDs = [];
      this.leftTransfer = [];
      this.showAdd = true;
      this.showDelect = false;
      this.kid = null;
    },
    //点击分类
    treeClick(data) {
      this.showDelect = true;
      this.showAdd = false;

      this.pid = data.pid;

      this.kindInfo = {
        id: data.id,
        name: data.name,
        url: data.url,
        type: data.type,
      };

      // 切换题目分类和浏览pdf页面
      this.showQuestion = this.kindInfo.type * 1 == 1;

      this.selectQ(this.kindInfo.id);

      this.kid = this.kindInfo.id;
      // this.$router.push({ path: `/kinds/kinds/edit.vue/${this.kid}` });
      if (this.currentNode == data) {
        this.currentNode = {};
        $(".el-tree-node").removeClass("is-current");
      } else {
        this.currentNode = data;
      }
    },

    //添加分类
    addKind() {
      let parameter = {
        id: "",
        name: "",
        sort: "",
        disabled: "",
      };

      if (parameter.id == "") {
        // (parameter.id = "0"),
        parameter.disabled = false;
        this.$refs.edit.open({ parameter }, "添加根节点");
      } else {
        if (parameter.id.length == 5) {
          parameter.disabled = false;
          this.$refs.edit.open(
            { parameter },
            "添加" + parameter.name + "子节点"
          );
        } else if (parameter.id.length == 9) {
          parameter.disabled = true;
          this.$refs.edit.open(
            { parameter },
            "无法添加" + parameter.name + "子节点，已达到最大层数"
          );
        }
        // else {
        // 	this.$refs.edit.open(null, '添加根节点');
        // }
      }
    },
    //去编辑
    toUpdate() {
      api.toUpdate({ id: this.kindInfo.id }, (res) => {
        let parameter = res.data;
        this.$refs.edit.open({ parameter }, "编辑");
      });
    },
    //pdf
    onProgress(progress) {
      //console.log('Loading progress:', progress);
    },
    onError(error) {
      //console.error('Error loading PDF:', error);
    },
    //pdf下一页
    nextPDF() {
      //console.log("下一页");

      if (this.currentPage < this.pageCount) {
        this.currentPage = this.currentPage + 1;
        this.$refs.pdf.page = this.currentPage;
      } else {
        this.currentPage = this.pageCount;
      }
    },
    //pdf上一页
    prevPDF() {
      //console.log("上一页");

      if (this.currentPage > 1) {
        this.currentPage = this.currentPage - 1;
        this.$refs.pdf.page = this.currentPage;
      } else {
        this.currentPage = 1;
      }
    },
    //移除分类
    remove() {
      let parameter = {
        ids: this.kindInfo.id,
      };
      this.$utils.confirm.warning("提示", "确定删除吗？", () => {
        api.remove(
          parameter,
          (response) => {
            this.$utils.msg.success(response.msg);
            this.list();
          },
          (response) => {
            this.$utils.msg.warning(response.msg);
          }
        );
      });
    },
    //查询该类未分类,查询已分类的表
    selectQ(kid) {
      api.selectQ(
        { kid },
        (response) => {
          //放入数据
          this.leftTransfer = this.generateData(1, response.data.leftQList);

          this.rightTransferQIDs = this.extractQids(response.data.rightQList);

          // 强制刷新 this.$forceUpdate();
        },
        (error) => {
          console.error("查询未分类表报错");
        }
      );
    },
    //查询对应课程的问题（未分类和已分类）
    selectQBySbid(sbid, kid) {
      api.selectQBySbid(
        { sbid, kid },
        (response) => {
          //放入数据
          this.leftTransfer = this.generateData(1, response.data.leftQList);
          this.rightTransferQIDs = this.extractQids(response.data.rightQList);
        },
        (error) => {
          console.error("查询未分类表报错");
        }
      );
    },
    //右侧选中时
    handleChange(newValue, direction, movedKeys) {
      this.rightTransferQIDs = newValue;
      this.qid = movedKeys;

      if (this.qid != null) {
        for (let i = 0; i < this.qid.length; i++) {
          const item = {
            kid: this.kid,
            qid: this.qid[i],
          };
          if (direction == "left") {
            api.deleteQ(item);
          } else if (direction == "right") {
            api.addQ(item);
          }
        }
      } else {
        console.log("qid为空");
      }
    },
    handleNodeClick(node) {
      this.fetchQuestions(node.id);
    },
  },
  mounted() {
    this.list();
  },
};
</script>

<style lang="scss" scoped="scoped">
@import "~common/custom/css/common.scss";

/deep/ .el-transfer-panel {
  width: 535px;
  /* 左右两个穿梭框的高度和宽度 */
  height: 700px;
  margin: auto;
}

/deep/ .el-transfer-panel__filter {
  width: 330px;
}

/deep/ .el-transfer-panel__list.is-filterable {
  height: 550px;
  /* 穿梭框列表高度 */
}

.pdf-container {
  height: 850px;
  /* 设置容器高度为100% */
  overflow-y: scroll;
  /* 启用滚动条 */
}
</style>
